import { atom } from 'jotai';

const initialJobSearchParamsFromState: JobSearchParams = {
  minTons: 1,
  maxTons: 27,
};

export const jobSearchParamsFromAtom = atom<JobSearchParams>(initialJobSearchParamsFromState);
